import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCardsStack = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "1em",
	viewBox: "0 -960 960 960",
	width: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M320-316q-33 0-56.5-23.5T240-396v-364q0-33 23.5-56.5T320-840h480q33 0 56.5 23.5T880-760v364q0 33-23.5 56.5T800-316H320Zm0-80h480v-364H320v364Zm0 0v-364 364ZM210-200Zm470-400q17 0 28.5-11.5T720-640q0-17-11.5-28.5T680-680H439q-17 0-28 11.5T400-640q0 17 11.5 28.5T440-600h240ZM560-480q17 0 28.5-11.5T600-520q0-17-11.5-28.5T560-560H439q-17 0-28 11.5T400-520q0 17 11.5 28.5T440-480h120ZM218-121q-33 5-59-15t-31-53L75-585q-2-17 8-30t27-15q16-2 29 7.5t15 26.5l56 396 274-38 164-23q18-3 32 9t14 31q0 15-10 26.5T659-181l-441 60Z" })
});
export default SvgCardsStack;
